import PicklistMetadata from "../PicklistMetadata";

// Static picklist sourced from the loaded pick values whose Type is "Rule Dimension"
// (display = Name, value = Value). Seeded by docs/Schema/rule_picklist_static_data.sql; the
// discriminator lives in PICK_TYPE, matching the Category Term Type convention.
class RuleDimensionPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "RuleDimension";
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Rule Dimension";
        this.useRealm = false;
        this.allowNoSelection = true;
    }
}

export default RuleDimensionPicklistMetadata;
